import { render, staticRenderFns } from "./EscuelaFotos.vue?vue&type=template&id=32af2cb0&"
import script from "./EscuelaFotos.vue?vue&type=script&lang=js&"
export * from "./EscuelaFotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports